<div class="top-bar flex" *ngIf="!simpleMenu" #topBar>
    <div style="width: 20%">
        <div class="top-bar-title login-with-fb">
            <div>
                <div class="position-wrap" id="position" #position>
                    <p style="margin-bottom: 0;">You are now viewing</p>
                    <h1>{{command.isEventCalendar ? 'EVENTS' : 'PLACES'}}</h1>
                </div>
            </div>
        </div>
    </div>
    <div style="width: 80%" class="btn-wrap">
        <div class="flex">

            <ig-event-filter style="flex: 8" *ngIf="command.isEventCalendar&&isEventEnabled" #eventFilter
                [isHideEditorChoice]="isHideEditorChoice" [customEvents]="customEvents"
                (onFilter)="searchText=''"></ig-event-filter>

            <div *ngIf="!command.isEventCalendar" class="top-bar-long-btn" style="flex: 4">
                <ng-container>
                    <ig-custom-default-place-category-accordion *ngIf="customDefaultPlaceCategory"
                        #customDefaultPlaceAccordion [toggleAndSource]="toggleAndSource" [selectedCategory]="category"
                        [menuType]="menuType" menuMode="topbar"
                        (onCategoryClick)="selectCustomDefaultPlaceCategory($event)"
                        (onNormalCategoryClick)="filterPlace($event)"
                        [customDefaultPlaceCategory]="customDefaultPlaceCategory"></ig-custom-default-place-category-accordion>
                </ng-container>
            </div>

            <div *ngIf="!command.isEventCalendar" style="flex: 4">
                <div *ngIf="!command.isEventCalendar">
                    <ig-custom-place-btn #customPlaceBtn
                        (onCustomPlaceSelected)="customPlaceBtnSelected($event)"></ig-custom-place-btn>
                </div>
            </div>
            <div style="flex: 4">
                <ig-button class="map-btn wide-btn top-bar-font-size" (trigger)="viewChange()">
                    <span>CLICK FOR MAP VIEW</span>
                    <mat-icon>room</mat-icon>
                </ig-button>
            </div>

            <div style="flex: 1">
                <div class="nav-top-bar-or">OR</div>
            </div>

            <div style="flex: 4">
                <form ngForm="searchFormGroup" class="relative">
                    <ig-field label="{{command.isEventCalendar?'search events':'search places'}}" [isInnerLabel]="true"
                        icon="{{searchParam.isSearching?'':'search'}}" [formControl]="searchFormGroup.get('searchText')"
                        [(ngModel)]="searchText" [class.is-filtering]="!!searchText" (keyup)="search($event)">
                    </ig-field>
                    <mat-spinner *ngIf="searchParam.isSearching" style="position: absolute; right:10px;top:12px"
                        [diameter]="22" [strokeWidth]="3"></mat-spinner>
                    <ig-alt-button (trigger)="search($event)"></ig-alt-button>

                </form>
            </div>
            <div style="flex: 4">
                <ig-button *ngIf="command.isEventCalendar&&featuresToggle.manualEvents"
                    class="map-btn wide-btn top-bar-font-size" (trigger)="addEventsManually()">
                    <span>Submit Your Event</span>
                    <mat-icon>input</mat-icon>
                </ig-button>
                <ig-button *ngIf="!command.isEventCalendar" class="map-btn wide-btn top-bar-font-size"
                    (trigger)="addPlacesManually()">
                    <span>Submit Your Place</span>
                    <mat-icon>input</mat-icon>
                </ig-button>
            </div>

            <div style="flex: 2">
                <ig-powered-by [style]="'iti-vertical'"></ig-powered-by>
            </div>

        </div>
    </div>
</div>


<ig-row class="top-bar" *ngIf="simpleMenu">
    <ig-col [xs]="3">
        <ig-row class="top-bar-title login-with-fb">
            <ig-col [xs]="9" [md]="9" [lg]="8">
                <ig-row class="row-top-title">
                    <ig-col [xs]="12">{{hubName}}</ig-col>
                </ig-row>
                <ig-row class="row-top-title">
                    <ig-col class="top-title" [xs]="12">
                        {{command.isEventCalendar ? 'Events' : 'Places'}}
                    </ig-col>
                </ig-row>
            </ig-col>
            <ig-col [xs]="3" [md]="3" [lg]="4">
                <!--<ig-fb-login-btn [isQuadrate]="true" #loginWithFBBtn></ig-fb-login-btn>-->
            </ig-col>
        </ig-row>
    </ig-col>
    <ig-col [xs]="9" class="btn-wrap">
        <ig-row>
            <ig-col class="top-bar-long-btn" [lg]="2">
                <div>
                    <ig-button class="long-btn" (trigger)="viewChange()" icon="room">
                        <span>CLICK FOR MAP VIEW</span>
                    </ig-button>
                </div>
            </ig-col>
            <ig-col [lg]="2">
                <form ngForm="searchFormGroup" class="search-wrap">
                    <ig-field label="search places" icon="search" [formControl]="searchFormGroup.get('searchText')"
                        [(ngModel)]="searchText" (keyup)="search()">
                    </ig-field>
                    <ig-alt-button (trigger)="search()"></ig-alt-button>
                </form>
            </ig-col>
        </ig-row>
    </ig-col>
</ig-row>


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/visitor/top.bar/visitor.top.bar.component.html